import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { AdminService } from 'src/app/admin/admin.service';

interface DialogData {

}

@Component({
  selector: 'app-bank-details',
  templateUrl: './bank-details.component.html',
  styleUrls: ['./bank-details.component.scss']
})
export class BankDetailsComponent implements OnInit {

  bankDetailsForm: FormGroup;
  bankData;

  constructor(
    private adminService: AdminService,
    private toastr: ToastrService,
    public dialogref: MatDialogRef<BankDetailsComponent>,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
  ) { }

  ngOnInit(): void {
    this.bankData = this.data["data"]

    this.bankDetailsForm = new FormGroup({
      'account_name': new FormControl("", Validators.required),
      'account_type': new FormControl("", Validators.required),
      'account_number': new FormControl("", [Validators.required, Validators.pattern(/^-?(0|[1-9]\d*)?$/), Validators.minLength(6)]),
      'bank_name': new FormControl("", Validators.required),
      'bank_branch': new FormControl("", Validators.required),
      'bank_ifsc': new FormControl("", [Validators.required]),
      'currency': new FormControl("", [Validators.required])
    });

    this.editBankDetailForm(this.bankData)
  }

  editBankDetailForm(data) {
    this.bankDetailsForm.controls['account_name'].setValue(data.account_name)
    this.bankDetailsForm.controls['account_type'].setValue(data.account_type)
    this.bankDetailsForm.controls['account_number'].setValue(data.account_number)
    this.bankDetailsForm.controls['bank_name'].setValue(data.bank_name)
    this.bankDetailsForm.controls['bank_branch'].setValue(data.bank_branch)
    this.bankDetailsForm.controls['bank_ifsc'].setValue(data.bank_ifsc)
    this.bankDetailsForm.controls['currency'].setValue(data.currency)
  }

  submitDetails() {
    if (this.bankDetailsForm.valid) {
      console.log(this.bankDetailsForm)
      let data = this.bankDetailsForm.value
      let form = {
        "vendor": {
          "bank_detail_attributes": {
            "account_name": this.bankDetailsForm.get('account_name').value,
            "account_type": this.bankDetailsForm.get('account_type').value,
            "account_number": this.bankDetailsForm.get('account_number').value,
            "bank_name": this.bankDetailsForm.get('bank_name').value,
            "bank_branch": this.bankDetailsForm.get('bank_branch').value,
            "bank_ifsc": this.bankDetailsForm.get('bank_ifsc').value,
            "currency": this.bankDetailsForm.get('currency').value
          }
        }
      }
      this.adminService.updateBankDetails(form).subscribe(
        res => {
          this.toastr.success('Updated Bank Details', 'Success');
          this.close()
        },
        err => {
          for (let i in err.error.errors) {
            this.toastr.error(err.error.errors[i], 'Error');
          }
        }
      )
    }
    else {
      this.toastr.error('Please check the respective fields', 'Error');
      return console.log(this.bankDetailsForm)
    }

  }

  close() {
    this.dialogref.close();
  }

}
